import './404.less';
import PropTypes from 'prop-types';
import React from 'react';

const Error = ({
	intl
}) => (
	<div className="error-page-404 container">
		<div className="content-container">
			<div className="error-page__banner" />
			<p className="error-page__title">404</p>
			<p className="error-page__desc">{ intl('Page not found') }</p>
		</div>
	</div>
);

Error.propTypes = {
	intl: PropTypes.func
};

export default Error;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/errors/404.js